import {DISPLAY_TOAST, REMOVE_TOAST} from './actions';


export function toasts(state = {}, action) {
    switch (action.type) {
        case DISPLAY_TOAST:
            return displayToast(state, action);
        case REMOVE_TOAST:
            return removeToast(state, action);
        default:
            return state;
    }
}

function displayToast(state, action) {
    return Object.assign({}, state, {
        [action.toastId]: action.props
    });
}

function removeToast(state, action) {
    /* eslint-disable no-unused-vars */
    const {[action.toastId]: removedToastProps, ...updatedToasts} = state;
    return updatedToasts;
}
